module.exports = __webpack_public_path__ + "static/media/pepe2.0c8482b1.png";